import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface CountriesState {
  countries: any
  country: any
  countryError: any
}

export const useCountriesStore = defineStore('countries', {
  state: (): CountriesState => ({
    countries: null,
    country: null,
    countryError: null,
  }),

  getters: {
    getCountries: (state) => state.countries,
    getCountry: (state) => state.country,
    getCountryError: (state) => state.countryError,
  },

  actions: {
    async fetchCountries() {
      try {
        const response = await api().get('configuration/address/country')
        this.countries = response.data
      } catch (error: any) {
        this.countryError = error.response?.data
      }
    },

    async createCountry(data: any) {
      try {
        const response = await api().post('configuration/address/country', data)
        this.country = response.data
      } catch (error: any) {
        this.countryError = error.response?.data
      }
    },

    async updateCountry(data: any) {
      try {
        const response = await api().post('configuration/address/country', data)
        this.country = response.data
      } catch (error: any) {
        this.countryError = error.response?.data
      }
    },
  },
})
